module.exports = __webpack_public_path__ + "be04df74f767fcd1693caa15aa080db2.png";